/*
 * Landmark Modal Messages
 */

import { defineMessages } from 'react-intl';

const scope = 'app.workspace.publications';

export default defineMessages({
  brief: {
    id: `${scope}.brief`,
    defaultMessage: `Brief contents is a lesson that's included in the frontmatter of the ebook.`,
  },
  start: {
    id: `${scope}.start`,
    defaultMessage: 'Start of content is the first lesson in the main contents, or bodymatter of the ebook.',
  },
  backmatter: {
    id: `${scope}.backmatter`,
    defaultMessage: 'Backmatter is the material that follows the main course content (such as an appendix, index, or resources list).',
  },
  done: {
    id: `${scope}.done`,
    defaultMessage: `DONE`,
  },
});
